/* eslint-disable react/display-name */
import React from 'react';

import { Icon, Spinner } from '@iwoca/orion';

import { DE_FULL_POSTCODE_LENGTH } from './PostcodeFilter';
import messages from '../BusinessIntroduction/BusinessIntroduction.messages';

const CompanySearchInput =
    ({
        resetFetchedCompanies,
        companiesFoundCount,
        hasMoreResults,
        intl,
        isPrefilledRegisteredCompanyWithoutCrefoId
    }) =>
    ({
        isLoading,
        openSearchMenu,
        closeSearchMenu,
        searchTerm,
        isSelected,
        selectedValue,
        setNewSearchTerm,
        resetSelection,
        isOpen
    }) => {
        if (isPrefilledRegisteredCompanyWithoutCrefoId && !isOpen) {
            openSearchMenu();
        }

        const meetsMinimumSearchRequirements = (searchTerm) =>
            searchTerm.length >= 3;
        const numberOfResultsText = `${companiesFoundCount}${
            hasMoreResults ? '+' : ''
        }`;
        const searchIcon = () =>
            isLoading ? (
                <Spinner size="small" dataTestId="loading-search-icon" />
            ) : (
                <Icon icon="zoomOutline" className="searchIcon" />
            );
        return (
            <div>
                <div className="addon-wrapper right">
                    <input
                        className="form-control"
                        value={
                            isSelected ? selectedValue : searchTerm.companyName
                        }
                        onKeyDown={(e) => {
                            // Stops enter key causing form errors showing by stopping form submit
                            if (e.which === 13) e.preventDefault();
                            if (isSelected) {
                                resetSelection();
                                setNewSearchTerm(
                                    { ...searchTerm, postcode: '' },
                                    { getNewOptions: false }
                                );
                            }
                        }}
                        onChange={(e) => {
                            if (
                                !meetsMinimumSearchRequirements(e.target.value)
                            ) {
                                resetFetchedCompanies();
                            }

                            const postcodeLessThanMinimum =
                                searchTerm.postcode.length <
                                DE_FULL_POSTCODE_LENGTH;
                            const isCompanyNameMinimumLength =
                                meetsMinimumSearchRequirements(e.target.value);
                            setNewSearchTerm(
                                {
                                    postcode:
                                        postcodeLessThanMinimum ||
                                        !isCompanyNameMinimumLength
                                            ? ''
                                            : searchTerm.postcode,
                                    companyName: e.target.value
                                },
                                { getNewOptions: isCompanyNameMinimumLength }
                            );
                        }}
                        onFocus={openSearchMenu}
                        onBlur={closeSearchMenu}
                        onClick={openSearchMenu}
                        autoComplete="off"
                        placeholder={`${intl.formatMessage(
                            messages.search
                        )}...`}
                    />

                    {companiesFoundCount && isOpen ? (
                        <span className="company-search-results-count">
                            {`${numberOfResultsText} Resultate`}
                        </span>
                    ) : (
                        searchIcon()
                    )}
                </div>
            </div>
        );
    };

export default CompanySearchInput;
